import { BaseModel } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';
import { IContract } from '../interface';

@Exclude()
export class ContractModel extends BaseModel implements IContract {
  @Expose() id!: number;
  @Expose() status!: 'completed' | 'processing';
  @Expose() docType!: 'lo';
  @Expose() name!: string;
}
